import tools from '../../../../assets/javascript/tools.js'
export default {
	columns: {
		name: {
			label: '套餐名称',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		achievementAmount: {
			label: '划卡业绩',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		deductAmount: {
			label: '提成金额',
			visible: true,
			width: 'auto',
			align: 'left',
		},
	},
}
